import { Injectable } from '@angular/core';
import { CoreSocketService } from './core-socket.service';
import { MessagingSocketService } from './messaging-socket.service';
import { QueueSocketService } from './queue-socket.service';
import { SttSocketService } from './stt-socket.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  constructor(
    private messagingSocketService: MessagingSocketService,
    private queueSocketService: QueueSocketService,
    private sttSocketService: SttSocketService,
    private coreSocketService: CoreSocketService
  ) {}

  public init() {
    this.messagingSocketService.initSocket();
    this.queueSocketService.initSocket();
    this.sttSocketService.initSocket();
    this.coreSocketService.initSocket();
  }
}
